import { atom } from "recoil";

export const authenticationTokenState = atom({
  key: "authenticationTokenState",
  default: null,
});
